import styled, { CSSObject } from 'styled-components';

export const defaultRowStyle: CSSObject = {};
export const TableRow = styled.tr(defaultRowStyle);
